'use client';

import { partnerApi, type Partner } from '@/app/(modules)/robot-manager/_lib/api';
import { Badge } from '@/app/(modules)/robot-manager/_lib/SimpleListPage';
import { CrudListPage } from '@/app/(modules)/robot-manager/_lib/CrudListPage';

export default function PartnersAdminPage() {
  return (
    <CrudListPage<Partner>
      title="合作伙伴"
      description="销售 agent / mentor / 报关行 / 培训方等跨模块合作主体"
      api={partnerApi}
      draftKey="platform-master:partner"
      inlineEditFields={['enabled']}
      formFields={[
        { key: 'code', label: '编码', type: 'text', placeholder: '留空自动生成（P-时间戳）', createOnly: true },
        { key: 'name', label: '名称', type: 'text', required: true },
        {
          key: 'role',
          label: '角色',
          type: 'select',
          required: true,
          options: [
            { value: 'SALES_AGENT', label: '销售代理' },
            { value: 'MENTOR', label: 'Mentor' },
            { value: 'MENTEE', label: 'Mentee' },
            { value: 'CUSTOMS_BROKER', label: '报关行' },
            { value: 'TRAINING_PARTNER', label: '培训方' },
          ],
        },
        { key: 'countryCode', label: '国家代码', type: 'text' },
        { key: 'currencyCode', label: '币种', type: 'text' },
        { key: 'enabled', label: '启用', type: 'boolean', defaultValue: true },
      ]}
      columns={[
        { key: 'code', label: '编码', width: '160px' },
        { key: 'name', label: '名称' },
        { key: 'role', label: '角色', width: '140px', render: (p) => <Badge text={p.role} /> },
        { key: 'countryCode', label: '国家', width: '80px' },
        { key: 'enabled', label: '启用', width: '80px', render: (p) => (p.enabled ? '✓' : '✗') },
      ]}
    />
  );
}
